import M from 'backbone.marionette'
import T from './recherche.html'
import Autocomplete from '../../utils/autocomplete/jquery.autocomplete'

export const RechercheView = M.View.extend({
    template:_.template(T),
    ac_ref: null,
    last_q_pressed: null,
    initialize: function(){
        $(document).on('keyup', _.bind(this.onKeyUp, this))
    },
    onKeyUp: function(keyEvent){
        if(keyEvent.which==81){
            const now = (new Date()).valueOf()
            if(this.last_q_pressed!==null){
                if((now - this.last_q_pressed) <= 1000){
                    // trigger it!
                    this.ui.recherche.focus();
                    this.ui.recherch.select();
                }
            }
            this.last_q_pressed = now;
        }
        console.log('keyEvent.which', keyEvent.which)
    },
    ui: {
        'recherche':'.recherche'
    },
    onRender: function(){
        this.ac_ref = this.ui.recherche.autocomplete({
			serviceUrl: './api/recherche',
            containerClass: 'autocomplete-suggestions recherche-principale',
            width: 350,
			onSelect: function (suggestion) {
                window.location.href = suggestion.url;
			},
            formatResult: function (_value, _obj, suggestion) {
                let str = '';
                switch(suggestion.type){
                    case 'user':
                        str = '<a href="'+suggestion.url+'"><strong>' + suggestion.data.first_name + (suggestion.data.nick_name ? ' <em>'+suggestion.data.nick_name + '</em>' : '') + ' ' + suggestion.data.last_name + '</strong><br /><small>';
                        if(suggestion.data.related_team){
                            str += '<img src="./img/team/logo/box_' + suggestion.data.related_team + '.png" width="30" height="15" />';
                        }
                        if(suggestion.data.related_jersey){
                            str += ' # ' + suggestion.data.related_jersey;
                        }
                        str += '</small></a>';
                        return str;
                        break;
                    case 'team':
                        str = '<a href="'+suggestion.url+'"><img src="./img/team/logo/orig_'+suggestion.id+'.png" width="30" height="30" /> ' + suggestion.data.team_code + ' - '  + suggestion.data.team_name + '</a>';
                        str += '<br /><small>';
                        for(let index in suggestion.acs){
                            str += suggestion.acs[index].program_code + ' <a class="btn btn-default btn-xs" href="./team/formation/'+suggestion.id+'?season_filter='+suggestion.acs[index].season_id+'"><span class="glyphicon glyphicon-user" aria-hidden="true"></span></a> <a class="btn btn-default btn-xs" href="./team/stats/'+suggestion.id+'?season_filter='+suggestion.acs[index].season_id+'"><span class="glyphicon glyphicon-signal" aria-hidden="true"></span></a> <a class="btn btn-default btn-xs" href="./team/calendar/'+suggestion.id+'?season_filter='+suggestion.acs[index].season_id+'"><span class="glyphicon glyphicon-calendar" aria-hidden="true"></span></a> ';
                        }
                        str += '</small>';
                        /*
                        if(suggestion.utype === 'ADMIN'){
                            str += '<br /><small><a class="btn btn-default btn-xs" href="./admin/team/'+suggestion.id+'">Admin</a></small>';
                        }
                        */
                        return str;
                        break;
                    default:
                        return '';
                        break;
                }
                console.log('formatResult', data)
                return suggestion;
            }
		});
    },

    

})